<!-- <div
	class="dark:bg-[#00000060] flex flex-col min-w-0 overflow-hidden inset-0 absolute m-auto h-full">
	<app-ultra-timeline [data]="data()" />
</div> -->

<div class="flex justify-center mt-15 w-full">
	<div class="flex flex-col justify-start items-center">
		<span class="text-hint max-w-sm text-center">Timeline comming soon </span>
	</div>
</div>
